import React, { useState } from "react";
import { toast } from "react-toastify";
import { generateNewJoinCode } from "../../../utils/generateNewJoinCode";
import { useT } from "../../../stores/uiLang";
import { TD_T } from "../../../i18n/teacherDashboard";

interface ClassCodeRowProps {
  id: string;
  name: string;
  joinCode: string;
  expiration?: string;
  onJoinCodeUpdate?: (newJoinCode: string) => void;
}

export default function ClassCodeRow({
  id,
  name,
  joinCode,
  expiration = "Never",
  onJoinCodeUpdate,
}: ClassCodeRowProps) {
  const t = useT(TD_T);
  const [isResetting, setIsResetting] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(joinCode).then(() => {
      toast.success("Join code copied to clipboard!");
    });
  };

  const handleReset = async () => {
    if (isResetting) return;

    setIsResetting(true);
    const { join_code, error } = await generateNewJoinCode(id);

    if (error) {
      toast.error(error);
    } else if (join_code) {
      toast.success("Join code reset successfully!");
      onJoinCodeUpdate?.(join_code);
    }

    setIsResetting(false);
  };

  return (
    <tr>
      <td className="px-6 py-4 text-gray-900 font-medium whitespace-nowrap">
        {name}
      </td>
      <td className="px-6 py-4 font-mono text-indigo-700 font-bold">
        {joinCode}
      </td>
      <td className="px-6 py-4 text-gray-500">{expiration}</td>
      <td className="px-6 py-4 text-right space-x-3">
        <button
          onClick={handleCopy}
          className="text-indigo-600 hover:text-indigo-900"
        >
          {t.copy}
        </button>
        <button
          onClick={handleReset}
          disabled={isResetting}
          className={`text-indigo-600 hover:text-indigo-900 ${
            isResetting ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {isResetting ? "Resetting..." : "Reset"}
        </button>
      </td>
    </tr>
  );
}
